import { Button } from '@mui/material'
import * as MuiIcons from '@mui/icons-material'

import { useMenu, usePermissions } from '../../../hooks'

/**
 * Renders a single MenuType.ACTION menu item as a real button -- RBAC-gated
 * (server-side requiredPermissions on the MenuItem, checked client-side here)
 * and i18n-translated (label comes from the seeded MenuItemTranslation row).
 *
 * Returns null while loading, if the action key isn't found, or if the
 * current user lacks every one of the item's requiredPermissions.
 */
export function ActionButton({ actionKey, onClick, variant = 'contained', ...buttonProps }) {
  const { menuItems, loading: menuLoading } = useMenu('ACTION')
  const { hasAnyPermission, loading: permissionsLoading } = usePermissions()

  if (menuLoading || permissionsLoading) return null

  const item = menuItems.find((menuItem) => menuItem.key === actionKey)
  if (!item) return null
  if (item.requiredPermissions?.length && !hasAnyPermission(item.requiredPermissions)) return null

  const Icon = item.icon ? MuiIcons[item.icon] : null

  return (
    <Button variant={variant} startIcon={Icon ? <Icon /> : undefined} onClick={onClick} {...buttonProps}>
      {item.label}
    </Button>
  )
}
